import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

// Register necessary chart components (Filler renders the `fill: true` area)
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Dashboard_LineChart = ({ chartData }) => {

  // const btbData = chartData;
  // // const btcData = pieData?.data?.BTC || {};

  // const btbOrders = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(
  //   (day) => btbData[day] || 0
  // );
  // // const btcOrders = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map(
  // //   (day) => btcData[day] || 0
  // // );

  const data = {
    labels: chartData?.map((i) => i?.date),
    datasets: [
      {
        label: 'Orders',
        data: chartData?.map((i) => i?.order_count),
        borderColor: '#8a5a36',
        backgroundColor: 'rgba(185, 139, 94, 0.18)',
        pointBackgroundColor: '#ffffff',
        pointBorderColor: '#8a5a36',
        pointBorderWidth: 2,
        pointRadius: 3,
        pointHoverRadius: 5,
        borderWidth: 2.5,
        fill: true,
        tension: 0.4,
      },
      // {
      //   label: 'BTC',
      //   data: btcOrders,
      //   borderColor: 'green',
      //   backgroundColor: 'rgba(0, 255, 0, 0.2)',
      //   fill: true,
      //   tension: 0.4,
      // },
    ],
  };


  const maxValue = Math.max(
    // ...btbOrders,
    // ...btcOrders
  );


  const axisText = { color: '#8c8178', font: { family: 'Manrope', size: 11 } };
  const axisTitle = { color: '#5b524b', font: { family: 'Manrope', size: 12, weight: '600' } };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: { color: '#5b524b', font: { family: 'Manrope', size: 12, weight: '600' }, usePointStyle: true },
      },
      tooltip: {
        backgroundColor: '#2b2622',
        titleFont: { family: 'Manrope', weight: '700' },
        bodyFont: { family: 'Manrope' },
        padding: 10,
        cornerRadius: 8,
        displayColors: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        border: { color: '#ebe1d3' },
        ticks: axisText,
        title: {
          display: true,
          text: 'Dates', // X-axis label
          ...axisTitle,
        },
      },
      y: {
        beginAtZero: true,
        grid: { color: 'rgba(235, 225, 211, 0.7)' },
        border: { display: false },
        ticks: {
          stepSize: 1,
          precision: 0,
          max: Math.ceil(maxValue), // Adjust Y-axis max value
          ...axisText,
        },
        title: {
          display: true,
          text: 'Order Count', // Y-axis label
          ...axisTitle,
        },
      },
    },
  };

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default Dashboard_LineChart;
